import { render, staticRenderFns } from "./version-management.vue?vue&type=template&id=54e8b148&scoped=true&"
import script from "./version-management.vue?vue&type=script&lang=js&"
export * from "./version-management.vue?vue&type=script&lang=js&"
import style0 from "./version-management.vue?vue&type=style&index=0&id=54e8b148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8b148",
  null
  
)

component.options.__file = "version-management.vue"
export default component.exports